import { Backdrop, CircularProgress } from '@material-ui/core';
import { OrderLeg } from 'doc-mate-store/lib/models/OrderLeg';
import { observer } from 'mobx-react-lite';
import React, { useCallback } from 'react';
// @ts-ignore
import { useLocation } from 'react-router';
import DataTable from '../../components/DataTable';

type Props = {
  fetching: boolean;
  loading: boolean;
};

const Table: React.FC<Props> = props => {
  const { fetching, loading } = props;
  const location = useLocation();
  const isAdditionalBilling = window.location.href.includes(
    'additional_billing',
  );
  const rowProps = useCallback(
    (row: { original: any }) => ({
      onDoubleClick: (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        // Remove 'table' parameter from query string
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('table');
        const searchStr = searchParams.toString();
        const cleanQuery = searchStr ? `?${searchStr}` : '';

        const targetUrl = isAdditionalBilling
          ? `/l/${(row.original as any).orderLegLinkId}/?billing=${row.original
              .id || row.original.billingType}`
          : `/l/${(row.original as OrderLeg).orderLegLinkId}${cleanQuery}`;

        window.open(targetUrl, '_blank', 'noopener,noreferrer');

        return false;
      },
    }),
    [isAdditionalBilling, location.search],
  );
  if (loading) {
    return (
      <Backdrop open>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <DataTable
      fetching={fetching}
      // tableProps={tableProps}
      getRowProps={rowProps}
    />
  );
};

export default React.memo(observer(Table));
